import React from "react";

type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
};

export function SectionHeading({ id, children }: SectionHeadingProps) {
  return (
    <h3 id={id} className="text-xl sm:text-2xl font-extrabold text-[var(--ink)] mt-10 mb-4 font-heading-condensed tracking-wide border-b border-[var(--line)] pb-2 uppercase text-left">
      {children}
    </h3>
  );
}
